/**
 * NOTE: RN's `refreshing`/`onRefresh` (pull-to-refresh via RefreshControl)
 * has no direct web equivalent — converted to a simple "Retry" button that
 * re-runs the same refresh callback, with the button itself reflecting the
 * `refreshing` state while a refetch is in flight.
 */
import React from 'react';

import { Search } from 'react-feather';
import { useIntl } from 'react-intl';

import { Spinner } from 'components';

import messages from '../messages';
import styles from '../States.module.scss';

const EmptyScreen = ({ text, refreshing, onRefresh }) => {
  const intl = useIntl();
  const defaultText = intl.formatMessage(messages.emptyMessage);

  return (
    <div className={styles.wrap}>
      <Search className={styles.icon} size={40} />
      <p className={styles.text}>{text || defaultText}</p>
      {onRefresh && (
        <button type="button" className={styles.retryBtn} onClick={onRefresh} disabled={refreshing}>
          {refreshing ? <Spinner show size="sm" /> : 'Refresh'}
        </button>
      )}
    </div>
  );
};

export default EmptyScreen;
